const Scorekeeper = require('watch-scorekeeper');
const log = require('loglevel').getLogger('lib/scorekeeper');
const PageAPI = require('lib/api').PageAPI;
const Promise = require('bluebird');

let scorekeeper;

export function scoreBuckets(buckets, preferences, influencers) {
    // only initialize one instance of ScoreKeeper
    if (!scorekeeper) {

        const dataSource = {
            getBasicInfluencers: () => Promise.resolve([]),
            getDynamicInfluencers: () => ((influencers) ? Promise.resolve(influencers) : PageAPI.getScoringInfluencers())
        };
        scorekeeper = new Scorekeeper({ dataSource });
    }

    if (!buckets) {
        return Promise.resolve();
    }
    const promises = buckets
        .filter((bucket) => {
            const metadata = bucket.metadata || {};
            return metadata.scored || bucket.scored || false;
        })
        .map((bucket) => {
            const contents = bucket.contents;
            return scorekeeper.scoreArray(contents, () => {}, preferences).then((scores) => {
                log.trace('scoreBuckets/scoreArray', contents, scores);
                //console.log("Scoring buckets with " + buckets + " and " + preferences + " and " + influencers);
                const scoredContents = contents
                    .map((obj, index) => {
                        const score = (scores[index] && scores[index].score) || 0;
                        return Object.assign({}, obj, { score: (obj.score || 0) + score });
                    })
                    .sort((itemA, itemB) => itemB.score - itemA.score);
                const scoredBucket = Object.assign({}, bucket, { contents: scoredContents });
                return scoredBucket;
            });
        });

    return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./app/lib/scorekeeper/index.js